<template>
  <div class="text-center">
    <v-form ref="form" lazy-validation>
      <CardHeader
        :message="message"
        :title="$t('account.letsGetToKnowYou')"
        :subtitle="$t('account.provideNameToContinue')"
      />
      <v-row dense>
        <v-col>
          <v-text-field
            v-model="first_name"
            :label="$t('account.firstName')"
            dense
            outlined
            :rules="[(v) => !!v || $t('account.firstNameRequired')]"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col>
          <v-text-field
            v-model="last_name"
            :label="$t('account.lastName')"
            dense
            outlined
            :rules="[(v) => !!v || $t('account.lastNameRequired')]"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row v-if="!isQrCodeOrOrientationFlow" dense>
        <v-col>
          <v-text-field
            v-model="password"
            :label="$t('password.passwordOptional')"
            dense
            outlined
            type="password"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row v-if="!isQrCodeOrOrientationFlow" dense>
        <v-col>
          <v-text-field
            v-model="verify_password"
            :label="$t('password.verifyPassword')"
            dense
            outlined
            type="password"
          ></v-text-field>
        </v-col>
      </v-row>

      <PrimaryButton :click="nextStep" :disabled="disable" class="mt-4">
        {{ $t('common.next') }}
      </PrimaryButton>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import CardHeader from '@/components/common/CardHeader'
import PrimaryButton from '@/components/common/PrimaryButton'
export default {
  components: {
    CardHeader,
    PrimaryButton,
  },
  data() {
    return {
      first_name: null,
      last_name: null,
      password: null,
      verify_password: null,
      disable: false,
    }
  },
  computed: {
    ...mapState({
      user: 'user',
      message: 'message',
      stage: 'stage',
      phoneIdentifier: 'phoneIdentifier',
      emailIdentifier: 'emailIdentifier',
    }),
    isQrCodeOrOrientationFlow() {
      const { qr, redirect_uri } = this.$route.query
      const redirectUri = redirect_uri || ''
      const isQrCode =
        !!qr ||
        redirectUri.includes('/q/') ||
        redirectUri.includes('/public/action/')
      const isWorkflow = redirectUri.includes('/workflow/')
      return isQrCode || isWorkflow
    },
  },
  watch: {
    stage: {
      handler() {
        this.clearForm()
      },
    },
    password: {
      handler() {
        this.checkPasswordInputs()
      },
    },
    verify_password: {
      handler() {
        this.checkPasswordInputs()
      },
    },
  },
  methods: {
    ...mapActions({
      resetState: 'resetState',
      createAndLogin: 'createAndLogin',
      setMessage: 'setMessage',
    }),
    checkPasswordInputs() {
      if (!this.password && !this.verify_password) {
        this.setMessage(null)
        return true
      }
      if (this.password !== this.verify_password) {
        this.setMessage(this.$t('password.passwordsDoNotMatch'))
        return false
      } else {
        this.setMessage(null)
        return true
      }
    },
    clearForm() {
      this.$refs.form.reset()
      this.first_name = this.user?.firstName || null
      this.last_name = this.user?.lastName || null
    },
    async nextStep() {
      this.setMessage(null)
      try {
        if (this.$refs.form.validate() && this.checkPasswordInputs()) {
          await this.createAndLogin({
            firstName: this.first_name,
            lastName: this.last_name,
            email: this.emailIdentifier,
            phone: this.phoneIdentifier,
            password: this.password,
          })
          this.disable = false
        }
      } catch (err) {
        this.disable = false
      }
    },
  },
}
</script>
